// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"BP-z","carousel":"CP-z"};